<template>
  <div class="filter-wrap">
    <div class="filterBar" ref="marketplaceRef">
      <div class="filterBar-content">
        <div class="item marketplace">
          <span>Marketplace</span>
          <artmisads-select
            style="width: 232px"
            v-model:value="props.params.marketplace"
            @change="onChangeCountry"
            :getPopupContainer="() => marketplaceRef"
          >
            <template v-for="option in COUNTRY_BASE" :key="option.countryCode"> 
              <a-select-option class="country-select-item" :value="option.host">
                <Icon :name="option.icon"></Icon>
                <span>{{ option.host }}</span>
              </a-select-option>
            </template>
          </artmisads-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import moment from "moment";

import { ref, watch } from "vue";

import { COUNTRY_BASE } from "~/contants/common";
import { FINANCE_SELLER_STATUS } from "~/contants/finance";
import Icon from '~/components/Icon.vue';
import { message } from "ant-design-vue";

const FINANCE_SELLER_STATUS_ALL = [{
  value: 'all',
  label: 'All'
}, ...FINANCE_SELLER_STATUS]

const COUNTRY_BASE_OPTIONS = COUNTRY_BASE.map((item) => {
  item.value = item.host;
  item.label = item.host;
  return item;
});

const dateParams = ref([moment().subtract(31, "day"), moment()]);
const marketplaceRef = ref(null);
const props = defineProps(["params", "setParams", "getData"]);

const onChangeCountry = marketplace => {
  const newParams = { ...props.params, marketplace };
  props.setParams(newParams);
}

const onReset = () => {
  props.setParams();
  dateParams.value = [moment().subtract(31, "day"), moment()];
};

const disabledDate = (current) => {
  if (!dateParams.value || dateParams.value.length === 0) {
    return false;
  }
  const tooLate =
    dateParams.value[0] && current.diff(dateParams.value[0], "days") > 365;
  const tooEarly =
    dateParams.value[1] && dateParams.value[1].diff(current, "days") > 365;
  return tooEarly || tooLate;
};

const openChange = (status) => {
  if (!status && dateParams.value) {
    const dateTime = {
      startBillingDateStr: dateParams.value[0].valueOf(),
      endBillingDateStr: dateParams.value[1].valueOf(),
    };
    const newParams = { ...props.params, ...dateTime };
    props.setParams(newParams);
  }
};

</script>
<style lang="less" scoped>
.filter-wrap {
  margin-top: 16px;
  :deep(.country-select-item) {
    .ant-select-item-option-content {
      display: flex;
      svg {
        align-self: center;
        margin-right: 4px;
      }
    }
  }
  .filterBar {
    padding: 16px;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #f8f7fc;
    border-radius: 8px;
    .filterBar-content {
      width: 100%;
      display: flex;
    }
  }
  .btn {
    display: flex;
    justify-content: right;
    button {
      margin-left: 15px;
    }
    > button {
      cursor: pointer;
      display: flex;
      margin-left: 16px;
      align-self: center;
      .shangchuan2 {
        width: 20px;
        height: 20px;
        fill: var(--dark-1);
        margin-right: 8px;
      }
      .jiantou {
        width: 16px;
        height: 16px;
        fill: var(--dark-3);
        margin-left: 8px;
      }
      .daochu {
        width: 20px;
        height: 20px;
        margin-right: 8px;
        fill: var(--dark-1);
      }
      > svg {
        align-self: center;
      }
      > span {
        align-self: center;
      }
      .btn-text {
        align-self: center;
        font-weight: 500;
        line-height: 20px;
        margin-right: 8px;
      }
    }
  }
  .item {
    display: flex;
    flex-direction: column;
    margin-right: 50px;
    > span {
      color: var(--dark-2);
      font-weight: 500;
      font-size: 13px;
      letter-spacing: 0.3px;
      line-height: 18px;
      margin-bottom: 4px;
    }
  }
  .marketplace {
    display: flex;
    align-content: center;
    :deep(.ant-select-selection-item),
    :deep(.ant-select-item-option-content) {
      display: flex;
      align-items: center;
      .iconfont {
        margin-right: 4px;
        font-size: 18px;
      }
    }
  }
}
</style>
